import {
  CaretDownSolid,
  CaretUpSolid,
} from '@alefeducation/ui-elements-library-icons';
import React from 'react';

interface TableSortIconProps {
  sort: 'asc' | 'desc';
}

const TableSortIcon: React.FC<TableSortIconProps> = ({ sort }) => {
  const caretUpColor = sort === 'asc' ? '#485464' : '#dbdde0';
  const caretDownColor = sort === 'desc' ? '#485464' : '#dbdde0';
  return (
    <div className="table-sort-icon">
      <CaretUpSolid height={8} width={8} color={caretUpColor} />
      <CaretDownSolid height={8} width={8} color={caretDownColor} />
    </div>
  );
};

export default TableSortIcon;
